// Utility functions for file handling

/**
 * Convert a File object to a base64 string
 * @param file - The File object to convert
 * @returns A Promise that resolves to the base64 string
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Extract base64 part after the comma
      const base64String = (reader.result as string).split(',')[1];
      resolve(base64String);
    };
    reader.onerror = error => reject(error);
  });
};

/**
 * Convert a File object to the format expected by Convex
 * @param file - The File object to convert
 * @returns A Promise that resolves to the Convex file object
 */
export const prepareFileForUpload = async (file: File) => {
  const base64String = await fileToBase64(file);
  return {
    buffer: base64String,
    filename: file.name,
    type: file.type,
    size: file.size,
  };
};